export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyA7Y65YMsFQgT67L69rNYBtyACkuBsanBo',
    authDomain: 'voters.terpeca.com',
    databaseURL: 'https://terpeca-voter-portal.firebaseio.com',
    projectId: 'terpeca-voter-portal',
    storageBucket: 'terpeca-voter-portal.appspot.com',
    messagingSenderId: '773402090327',
    appId: '1:773402090327:web:a1fda8e06a22a0e41fbc12'
  },
  projectTitle: 'TERPECA',
  roomFinderHostname: 'roomfinder.terpeca.com',
  rollbarAccessToken: '085d259ff07a498695eb813592558091e176ef130552e16d72fc2fd81e60e6a487c0a0db5e296ac26bf1ec46a9fc380f',
  toolbarColor: '#111111',
  googleAnalyticsMeasurementId: 'G-QQZGH6MGKG',
  currentAwardYear: 2026
};
